import { BaseWebComponent } from "./webcomponent-base";

export class SidebarDividerWebComponent extends BaseWebComponent {
    static webComponentName = "wc-sidebar-divider";
    static observedAttributes = [];
    constructor() {
        super();
    }
    render(): void {
        return ; // non c'è niente da renderizzare
    }
}

